import React, {useCallback, useEffect, useState} from 'react';
import {NewsList} from "../../../components/admin/news/NewsList";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {Pagination} from "../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";
import {defaultPagination} from "../../../types/PaginationType";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {newsResultCollectionType, newsResultType} from "../../../types/Api/NewsResultType";
import {newsHydrator} from "../../../models/hydrator/newsHydrator";
import {news} from "../../../models/news";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState([] as news[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findNews = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'enabled',
      direction: 'DESC'
    });

    apiFilters.addSort({
      by: 'order',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<newsResultCollectionType> = ApiService.get('/news', apiFilters) as Promise<newsResultCollectionType>;

    result
      .then((r: newsResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setNews(r._embedded.newss.map((news: newsResultType) => {
          return newsHydrator.hydrate(news);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination({
          page: 0,
          pageCount: 0,
          total: 0,
          count: count,
        });
        setNews([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findNews();
  }, [findNews]);

  return (
    <>
      <BoxTitle title="Gestion des actualités"/>
      <NewsList news={news} loading={loading} refresh={findNews}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 d-flex justify-content-between">
        <NavLink to={`/admin/news/order`} onClick={scrollTo} className="btn btn-sm btn-info">
          <i className="fa-solid fa-shuffle me-1"/> Modifier l'ordre
        </NavLink>

        <NavLink to={`/admin/news/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une actualité
        </NavLink>
      </div>
    </>
  )
}